<template>
    <a href="/">
        <img id="logo" src="@/assets/images/logo.png" />
    </a>
</template>

<script>
export default {
    name: "logo-img"
};
</script>

<style scoped>
#logo {
    width: 156px;
    margin-top: 20px;
}
</style>
